module.exports = __webpack_public_path__ + "static/img/headImg.72b6be40.png";